import { useState } from 'react';

const faqs = [
  {
    q: 'Why is the Chrome extension not autofilling my application?',
    a: 'Make sure your Master Profile is complete (at least 80% filled). Then click the JobOS icon on the job page and hit "Autofill Now". If the form still doesn\'t fill, the ATS may have updated its layout — please report it via the contact form below and we\'ll push a fix within 48 hours.',
  },
  {
    q: 'How do I import jobs I\'ve already applied to?',
    a: 'Go to your Dashboard → Applications → "Import" button. You can paste a CSV export from LinkedIn, Indeed, or any spreadsheet. The importer maps columns automatically.',
  },
  {
    q: 'Can I use JobOS on multiple devices?',
    a: 'Yes. Your account syncs across all browsers and devices. Install the Chrome extension on each machine and sign in — your profile, applications, and settings will be available everywhere.',
  },
  {
    q: 'How do I cancel my Pro subscription?',
    a: 'Go to Settings → Billing → "Cancel Plan". Your Pro features remain active until the end of the current billing period. No questions asked, no hidden fees.',
  },
  {
    q: 'Is my resume data stored securely?',
    a: 'Yes. All data is encrypted in transit (TLS 1.3) and at rest (AES-256). We are PIPEDA compliant and never sell or share your personal data with third parties.',
  },
  {
    q: 'Does JobOS work with Naukri.com and Rozee.pk?',
    a: 'Yes! JobOS natively supports Naukri.com, Rozee.pk, and 7+ other global ATS platforms. See the full list on our Supported ATS Platforms page.',
  },
  {
    q: 'How many AI credits do I get on the free plan?',
    a: 'The Free plan includes 10 AI tailoring credits per month. Pro users get unlimited AI credits. Credits reset on the 1st of each month.',
  },
  {
    q: 'Can I request a new ATS platform or job board?',
    a: 'Absolutely. Use the contact form below or visit our public Roadmap to upvote existing requests. High-demand platforms are typically added within 2–4 weeks.',
  },
];

export default function SupportFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 bg-gray-50 dark:bg-[#060A14]">
      <div className="max-w-[860px] mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-3 tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-500 dark:text-[#94A3B8] text-base">
            Quick answers to the most common support questions.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-white dark:bg-[#111827] border border-gray-100 dark:border-[#1E2A3B] rounded-xl overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer group"
              >
                <span className="text-sm font-semibold text-gray-900 dark:text-white pr-4 leading-snug group-hover:text-[#6366F1] dark:group-hover:text-[#818CF8] transition-colors">
                  {faq.q}
                </span>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${openIndex === i ? 'subtract' : 'add'}-line text-lg text-[#6366F1]`}></i>
                </span>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-gray-600 dark:text-[#94A3B8] leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
